const FloatingButtons = () => {
  const whatsappMessage = encodeURIComponent('Merhaba, izmirtadilatfirmasi.com web siteniz üzerinden yazıyorum.\nTadilat, dekorasyon ve iç mimarlık hizmetleriniz hakkında bilgi ve fiyat teklifi almak istiyorum.');
  
  return (
    <div className="fixed bottom-6 right-6 md:bottom-8 md:right-8 z-40 flex flex-col space-y-3 md:space-y-4">
      {/* WhatsApp Button */}
      <a
        href={`https://wa.me/905421138110?text=${whatsappMessage}`}
        target="_blank"
        rel="noopener noreferrer"
        className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center bg-[#25D366] text-white rounded-full shadow-lg hover:scale-110 transition-transform duration-300 cursor-pointer"
        aria-label="WhatsApp ile iletişime geç"
      >
        <i className="ri-whatsapp-line text-xl md:text-2xl"></i>
      </a>

      {/* Phone Button */}
      <a
        href="tel:05421138110"
        className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center bg-wood-dark text-white rounded-full shadow-lg hover:scale-110 transition-transform duration-300 cursor-pointer"
        aria-label="Telefon ile ara"
      >
        <i className="ri-phone-line text-xl md:text-2xl"></i>
      </a>
    </div>
  );
};

export default FloatingButtons;
